import { clickButtonGtmTag, initPagePush } from "../libs/gtm";

export const gtmAnalyticHandlersInit = () => {
  const savedReferrer = sessionStorage.getItem('savedReferrer');

  // Условие отправки pageview в аналитику:
  // - если авторизация через ВК недоступна
  // - если включен автозаполнение формы,
  // - или если пользователь уже авторизован через ВК
  // eslint-disable-next-line
  const isVkAuthDisabled = (typeof vkConnect === 'undefined' || !vkConnect || typeof vkConnectId === 'undefined' || !vkConnectId);
  const isNeedAutocomplete = window.cFormAutocomplete?.isNeedAutocomplete;
  const isVkAlreadyAuthenticated = window.localStorage.getItem('is_vk_auth') !== null;

  if (isVkAuthDisabled || isNeedAutocomplete || isVkAlreadyAuthenticated) {
    window.$analytics?.push('pageview', { referrer: savedReferrer });
  }

  initPagePush()

  const page = document.querySelector('body');

  page.addEventListener('click', (evt) => {
    const isButton = Boolean(evt.target.closest('.ui-button'));

    isButton && clickButtonGtmTag('enroll');
  });
};
